module.exports = __webpack_public_path__ + "static/sport/slide4.b8c2b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/slide4.png
// module id = SDWD
// module chunks = 0